export const userTranslations = {
    en: {
        // User Management
        usersManagement: 'Users Management',
        manageUsers: 'Manage Users',
        createUser: 'Create User',
        roles: {
            admin: 'Administrator',
            cashier: 'Cashier'
        },
        userSettingsTitle: 'User Settings',
        userConfig: 'User Configuration',
        requirePasswordChange: 'Require Password Change on First Login',
        sessionTimeout: 'Session Timeout (minutes)',
        sessionTimeoutHelp: 'Time in minutes before an inactive user is logged out',
        maxLoginAttempts: 'Maximum Login Attempts',
        allowUserRegistration: 'Allow User Registration',
        requireEmailVerification: 'Require Email Verification',
        defaultRole: 'Default User Role'
    },
    ar: {
        // User Management
        usersManagement: 'إدارة المستخدمين',
        manageUsers: 'إدارة المستخدمين',
        createUser: 'إنشاء مستخدم',
        roles: {
            admin: 'مدير النظام',
            cashier: 'أمين الصندوق'
        },
        userSettingsTitle: 'إعدادات المستخدمين',
        userConfig: 'تكوين المستخدم',
        requirePasswordChange: 'طلب تغيير كلمة المرور عند أول تسجيل دخول',
        sessionTimeout: 'مهلة الجلسة (بالدقائق)',
        sessionTimeoutHelp: 'الوقت بالدقائق قبل تسجيل خروج المستخدم غير النشط',
        maxLoginAttempts: 'الحد الأقصى لمحاولات تسجيل الدخول',
        allowUserRegistration: 'السماح بتسجيل المستخدمين',
        requireEmailVerification: 'طلب تأكيد البريد الإلكتروني',
        defaultRole: 'الدور الافتراضي للمستخدم'
    }
};
